import React, { useState, useEffect } from "react";
import DataGrid, { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import Card from "components/card";
import { PageSection, PageHeaderBar } from "components/page";
import {getOccurrenceSources} from "../../../../services/commonService";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";

const MatchPointConfigApiForm = ({ intl, eventToEdit = {}, register, watch, errors }) => {
  const [showForm, setShowForm] = useState(false);
  const [occurrencesSourceTypes, setOccurrencesSourceTypes] = useState(null);

  const occurrenceSourcesCallback = (r) => {
      setOccurrencesSourceTypes(r);
      setShowForm(!!r?.length);
  }

    useEffect(() => {
        const params = {
            contractId: eventToEdit?.service_contract_id,
            eventTypeId: eventToEdit?.event_type_id,
        }

        getOccurrenceSources(params, occurrenceSourcesCallback)
    }, []);

  return showForm ? (
    <>
      <PageHeaderBar subtitle title="event.sportEventData.matchPointConfig" />
      <PageSection hideBackground>
        <DataGrid>
          <Card>
            <DataGridItem>
                <FormControl style={{ width: "100%" }}>
                    <InputLabel id="matchPointConfig.ocurrencesSource">{intl.formatMessage({id: "event.matchPointConfig.ocurrencesSource"})}</InputLabel>
                    <Select {...register("matchPointConfig.ocurrencesSource")}
                            value={watch("matchPointConfig.ocurrencesSource") ?? ""}
                            getLabelFromElement={item => item}
                            getValueFromElement={item => item}
                            id="matchPointConfig.ocurrencesSource">
                        <MenuItem value="">
                            <em>{intl.formatMessage({id: "common.none"})}</em>
                        </MenuItem>
                        {occurrencesSourceTypes.map((type) => (
                            <MenuItem key={type} value={type}>
                                {type}
                            </MenuItem>))}
                    </Select>
                </FormControl>
            </DataGridItem>
            <DataGridItem>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={watch("matchPointConfig.ocurrencesVisible")}
                            {...register("matchPointConfig.ocurrencesVisible")}
                            name="matchPointConfig.ocurrencesVisible"
                            id="matchPointConfig.ocurrencesVisible"
                            color="secondary"
                        />
                    }
                    label={intl.formatMessage({id: "event.matchPointConfig.ocurrencesVisible"})}
                />
            </DataGridItem>
            <DataGridItem big>
                <TextField
                    {...register("matchPointConfig.ocurrencesSourceId")}
                    id="matchPointConfig.ocurrencesSourceId"
                    type="text"
                    style={{ width: "100%" }}
                    placeholder={intl.formatMessage({id: "event.matchPointConfig.ocurrencesSourceId"})}
                    label={intl.formatMessage({id: "event.matchPointConfig.ocurrencesSourceId"})}
                    error={!!errors.matchPointConfig?.ocurrencesSourceId}
                    helperText={errors.matchPointConfig?.ocurrencesSourceId?.message}
                />
            </DataGridItem>
          </Card>
        </DataGrid>
      </PageSection>
    </>
  ) : null;
};

MatchPointConfigApiForm.propTypes = {
  /**
   * Valores del formulario
   */
  values: PropTypes.object,
  /**
   * Otros datos del evento a editar que no se envían en el form
   */
  eventToEdit: PropTypes.object,
  /**
   * Callback que se dispara con el cambio del input
   */
  handleChange: PropTypes.func,
};

export default injectIntl(MatchPointConfigApiForm);
